<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'findUs'"
    class="page"
  >
    <Header
      :setting="{
        title: '交通資訊',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div class="align--left fs4 fc--primary ml3 mb4">
      {{ spiderman.clinic[composable.member.info.clinic].fullname }}
    </div>
    <img
      :src="info.findUsPictureUrl"
      alt=""
      class="image--size-x-fit mb4"
    >
    <div class="page__text align--left fs-3 fc--primary mb3">
      {{ info.findUsAddress }}
    </div>
    <div class="row--end">
      <div
        @click="toMap(info.findUsAddress,composable.member.info.clinic)"
        class="label label--primary"
      >
        <div class="row--central">
          <font-awesome-icon :icon="['fas', 'map']" />
          <div class="ml1">
            前往地圖
          </div>
        </div>
      </div>
    </div>
  </div>
  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';

export default {
  setup() {
    const page = ref('initialization');
    const info = ref(null);
    const router = useRouter();
    const route = useRoute();

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        info.value = (await api.introductions.get(composable.member));

        page.value = 'findUs';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    function toMap(address, clinic) {
      const cmd = spiderman.generate.specialCommand({
        cmd: 'browse',
        url: encodeURI(`https://www.google.com/maps/search/?api=1&query=${address}${clinic}`),
        timestamp: spiderman.generate.timestamp(),
      });
      router.replace(`${route.path}#inncom#${cmd}`);
    }

    return {
      page,
      composable,
      info,
      spiderman,
      toMap,
    };
  },
};
</script>
